import React, { ReactElement } from 'react';
import styled from 'styled-components';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const AddEditRoleComp = React.lazy(
  () => import('../components/UserAndRoles/RoleAndPermissions/AddEditRole')
);

const LocationsContainer = styled.div`
  padding: 5px;
`;

function UserAndRoles(): ReactElement {
  return (
    <SuspenseLoadPage>
      <LocationsContainer>
        <AddEditRoleComp />
      </LocationsContainer>
    </SuspenseLoadPage>
  );
}

export default UserAndRoles;
